export type LicenseStatus = 'ACTIVE' | 'NOT_ACTIVE' | 'CHURNED' | 'EXPIRED';
export type LicenseTrialStatus = 'NONE' | 'ACTIVE' | 'CONVERTED' | 'EXPIRED';
export type LicenseSubscriptionPlan = 'Tier1' | 'Tier2' | 'Tier3';
export type LicenseName = 'SLA' | 'STANDALONE';

export interface OrganizationLicense {
  id?: number;
  organizationId?: number;
  status: LicenseStatus;
  name: LicenseName;
  subscriptionPlan: LicenseSubscriptionPlan;
  trialStatus: LicenseTrialStatus;
  trialStartDate?: string;
  trialEndDate?: string;
}

export interface LicensingStateModel {
  licenses: OrganizationLicense[];
  selected?: OrganizationLicense;
  isLoading: boolean;
  error?: string;
  success?: string;
}

export const LICENSE_STATUSES: LicenseStatus[] = ['ACTIVE', 'NOT_ACTIVE', 'CHURNED', 'EXPIRED'];
export const LICENSE_TRIAL_STATUSES: LicenseTrialStatus[] = ['NONE', 'ACTIVE', 'CONVERTED', 'EXPIRED'];
export const LICENSE_SUBSCRIPTION_PLANS: LicenseSubscriptionPlan[] = ['Tier1', 'Tier2', 'Tier3'];
export const LICENSE_SUBSCRIPTION_PLAN_NAMES: LicenseName[] = ['SLA', 'STANDALONE'];

export const DEFAULT_LICENSE_PROPERTIES: OrganizationLicense = {
  status: 'ACTIVE',
  name: 'STANDALONE',
  subscriptionPlan: 'Tier1',
  trialStatus: 'ACTIVE',
  trialStartDate: undefined,
  trialEndDate: undefined,
};
